import {
  login,
  logout,
  recoverPassword,
  updatePassword
} from '@/api/auth'
import { storeSession, rawLogout } from '@/lib/session'

const state = {
  user: null,
  authenticated: false,
  isLoading: false
}

const getters = {
  isAdmin: state => state.authenticated && state.user.admin
}

const actions = {
  clean ({ commit }) {
    commit('clean')
  },

  setSession ({ commit }, user) {
    const {
      admin,
      name,
      tags,
      systemmodules,
      usertype
    } = user

    commit('setSession', {
      admin,
      name,
      tags,
      systemmodules,
      usertype
    })
  },

  async logout ({ commit }) {
    try {
      await logout()
    } catch (e) { }
    rawLogout()
    commit('clean')
  },

  async login ({ dispatch, commit }, user) {
    commit('setLoading', true)
    try {
      const userData = await login(user)

      // Dados que ficarao na memoria
      dispatch('setSession', userData)

      // Salvos no local storage
      storeSession(userData)

      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }

    return false
  },

  async recoverPassword({ dispatch, commit }, email) {
    try {
      await recoverPassword(email)

      return { result: true }
    } catch (error) {
      return { result: false, message: error.message }
    }
  },

  async updatePassword({ dispatch, commit }, data) {
    try {
      await updatePassword(data)

      return { result: true }
    } catch (error) {
      return { result: false, message: error.message }
    }
  }
}

const mutations = {
  clean (state) {
    state.isLoading = false
    state.authenticated = false
    state.user = null
  },

  setLoading (state, loading) {
    state.isLoading = loading
  },

  setSession (state, sessionData) {
    state.authenticated = true
    state.user = sessionData
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
